import type { Color, RGBColor } from '@sorare/core/src/style/types';

export const taskThresholdscColors: { color: Color; rgbColor: RGBColor }[] = [
  { color: 'var(--c-score-medium)', rgbColor: 'var(--c-rgb-score-medium)' },
  { color: 'var(--c-yellow-400)', rgbColor: 'var(--c-rgb-yellow-400)' },
  {
    color: 'var(--c-limited-secondary)',
    rgbColor: 'var(--c-rgb-limited-secondary)',
  },
  { color: 'var(--c-rewards-orange)', rgbColor: 'var(--c-rgb-rewards-orange)' },
  { color: 'var(--c-rare)', rgbColor: 'var(--c-rgb-rare)' },
];
